var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNextArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 20,
    viewBox: "0 0 24 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.6875 11.6355L12.8413 17.4813C12.5649 17.7646 12.432 18.0978 12.4425 18.4809C12.4531 18.8639 12.5999 19.1938 12.883 19.4705C13.1663 19.7535 13.4978 19.8934 13.8775 19.8901C14.2575 19.887 14.5857 19.7471 14.8621 19.4705L23.1221 11.2205C23.4055 10.9371 23.5471 10.6023 23.5471 10.2159C23.5471 9.8295 23.4055 9.49464 23.1221 9.21131L14.8205 0.919643C14.5441 0.642977 14.2159 0.503115 13.8359 0.50006C13.4561 0.496726 13.1246 0.633255 12.8413 0.909644C12.5582 1.19298 12.4184 1.53312 12.4217 1.93006C12.425 2.327 12.5649 2.66381 12.8413 2.94048L18.6875 8.79631H1.41917C1.01167 8.79631 0.673195 8.93103 0.403752 9.20048C0.134585 9.46992 0 9.80839 0 10.2159C0 10.6234 0.134585 10.9619 0.403752 11.2313C0.673195 11.5008 1.01167 11.6355 1.41917 11.6355H18.6875Z",
    fill: "currentColor",
    fillOpacity: 1
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNextArrow);
export default __webpack_public_path__ + "static/media/nextArrow.27591f9952991a7895d1266cbd70f9be.svg";
export { ForwardRef as ReactComponent };